import { render, staticRenderFns } from "./Hourglass.vue?vue&type=template&id=5f2531c2&scoped=true&"
import script from "./Hourglass.vue?vue&type=script&lang=js&"
export * from "./Hourglass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2531c2",
  null
  
)

export default component.exports